import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Navigate between room views while PRESERVING the URL search string — critically the `?t=<invite>`
 * token. Keeping the invite in the URL is what makes a hard refresh recoverable: the SessionProvider
 * re-exchanges it (the session bearer itself is in memory only and never persisted). See
 * SessionProvider for the refresh-recovery contract note.
 */
export function useRoomNav(): (pathname: string) => void {
  const navigate = useNavigate();
  const { search } = useLocation();
  return useCallback((pathname: string) => navigate({ pathname, search }), [navigate, search]);
}
